var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 3000 2160",
    id: "mobile-app",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1500,
    height: 1080,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-169.225 -28.205) scale(1.12312)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e3ee",
    d: "M-179.056,1007.99C-179.056,996.381 -190.289,986.953 -204.124,986.953L-270.004,986.953C-283.84,986.953 -295.072,996.381 -295.072,1007.99L-295.072,1181.93C-295.072,1193.55 -283.84,1202.97 -270.004,1202.97L-204.124,1202.97C-190.289,1202.97 -179.056,1193.55 -179.056,1181.93L-179.056,1007.99Z",
    transform: "matrix(.83464 -.48188 1.14837 .66301 -187.339 -79.811)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7887da",
    d: "M754.683,92.798C760.184,89.597 767.366,89.882 775.22,94.416L970.704,207.279C987.993,217.26 1002.03,244.079 1002.03,267.131L1002.03,791.479C1002.03,802.812 998.637,811.138 993.133,815.489L993.193,815.652L958.269,835.816L941.986,791.531L781.325,698.774C764.036,688.792 750,661.973 750,638.921L743.895,198.73L719.759,112.961L754.683,92.798Z"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M754.683,92.798C760.184,89.597 767.366,89.882 775.22,94.416L970.704,207.279C987.993,217.26 1002.03,244.079 1002.03,267.131L1002.03,791.479C1002.03,802.812 998.637,811.138 993.133,815.489L993.193,815.652L958.269,835.816L941.986,791.531L781.325,698.774C764.036,688.792 750,661.973 750,638.921L743.895,198.73L719.759,112.961L754.683,92.798Z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119.815,
    height: 346.331,
    x: 1063.14,
    y: 753.865,
    fill: "#4b61dc",
    transform: "matrix(.5076 -.29306 0 1.58978 413.326 -596.748)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#10243e",
    d: "M1116.69,-234.73C1116.69,-254.693 1100.49,-270.901 1080.52,-270.901L854.799,-270.901C834.836,-270.901 818.628,-254.693 818.628,-234.73L818.628,219.369C818.628,239.333 834.836,255.54 854.799,255.54L1080.52,255.54C1100.49,255.54 1116.69,239.333 1116.69,219.369L1116.69,-234.73Z",
    transform: "rotate(30) skewX(30)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.77136 .44534 0 1.09309 91.606 50.436)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e3ee",
    d: "M1116.69,-236.868C1116.69,-255.651 1100.49,-270.901 1080.52,-270.901L854.799,-270.901C834.836,-270.901 818.628,-255.651 818.628,-236.868L818.628,225.129C818.628,243.912 834.836,259.162 854.799,259.162L1080.52,259.162C1100.49,259.162 1116.69,243.912 1116.69,225.129L1116.69,-236.868Z"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1116.69,-236.868C1116.69,-255.651 1100.49,-270.901 1080.52,-270.901L854.799,-270.901C834.836,-270.901 818.628,-255.651 818.628,-236.868L818.628,225.129C818.628,243.912 834.836,259.162 854.799,259.162L1080.52,259.162C1100.49,259.162 1116.69,243.912 1116.69,225.129L1116.69,-236.868Z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200.463,
    height: 70.464,
    x: 880.273,
    y: -160.442,
    fill: "#f2f3f7",
    transform: "matrix(1.48689 0 0 1.8014 -490.245 6.956)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f3f7",
    d: "M963.423,-95.484C963.423,-102.276 961.955,-107.791 960.146,-107.791L856.506,-107.791C854.697,-107.791 853.229,-102.276 853.229,-95.484L853.229,-24.666C853.229,-17.874 854.697,-12.36 856.506,-12.36L960.146,-12.36C961.955,-12.36 963.423,-17.874 963.423,-24.666L963.423,-95.484Z",
    transform: "matrix(1.80739 1.0435 0 .64163 -800.959 -532.906)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e3ee",
    d: "M963.423,-60.075C963.423,-86.41 959.617,-107.791 954.929,-107.791L861.723,-107.791C857.035,-107.791 853.229,-86.41 853.229,-60.075C853.229,-33.741 857.035,-12.36 861.723,-12.36L954.929,-12.36C959.617,-12.36 963.423,-33.741 963.423,-60.075Z",
    transform: "matrix(1.54674 .89301 0 .36711 -564.207 -412.71)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7887da",
    d: "M963.423,-60.075C963.423,-86.41 957.132,-107.791 949.382,-107.791L867.27,-107.791C859.52,-107.791 853.229,-86.41 853.229,-60.075C853.229,-33.741 859.52,-12.36 867.27,-12.36L949.382,-12.36C957.132,-12.36 963.423,-33.741 963.423,-60.075Z",
    transform: "matrix(.73829 .42625 0 .28966 129.456 -16.876)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f3f7",
    d: "M963.423,-95.484C963.423,-102.276 961.955,-107.791 960.146,-107.791L856.506,-107.791C854.697,-107.791 853.229,-102.276 853.229,-95.484L853.229,-24.666C853.229,-17.874 854.697,-12.36 856.506,-12.36L960.146,-12.36C961.955,-12.36 963.423,-17.874 963.423,-24.666L963.423,-95.484Z",
    transform: "matrix(1.80739 1.0435 0 .64163 -800.959 -196.886)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 971.098,
    cy: 199.899,
    fill: "#4b61dc",
    rx: 18.047,
    ry: 15.629,
    transform: "rotate(30 47.183 -151.383) skewX(30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 971.098,
    cy: 199.899,
    fill: "#4b61dc",
    rx: 18.047,
    ry: 15.629,
    transform: "rotate(30 20.582 -52.104) skewX(30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 971.098,
    cy: 199.899,
    fill: "#4b61dc",
    rx: 18.047,
    ry: 15.629,
    transform: "rotate(30 -6.02 47.176) skewX(30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 971.098,
    cy: 199.899,
    fill: "#4b61dc",
    rx: 18.047,
    ry: 15.629,
    transform: "rotate(30 -32.622 146.455) skewX(30)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f3f7",
    d: "M963.423,-100.917C963.423,-104.711 961.895,-107.791 960.014,-107.791L856.638,-107.791C854.757,-107.791 853.229,-104.711 853.229,-100.917L853.229,-19.234C853.229,-15.44 854.757,-12.36 856.638,-12.36L960.014,-12.36C961.895,-12.36 963.423,-15.44 963.423,-19.234L963.423,-100.917Z",
    transform: "matrix(1.80739 1.0435 0 1.19523 -800.959 -393.257)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f3f7",
    d: "M963.423,-100.917C963.423,-104.711 961.895,-107.791 960.014,-107.791L856.638,-107.791C854.757,-107.791 853.229,-104.711 853.229,-100.917L853.229,-19.234C853.229,-15.44 854.757,-12.36 856.638,-12.36L960.014,-12.36C961.895,-12.36 963.423,-15.44 963.423,-19.234L963.423,-100.917Z",
    transform: "matrix(1.80739 1.0435 0 1.19523 -800.959 -265.634)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10243e",
    d: "M1007.31,-219.891C1007.31,-226.147 1002.57,-231.225 996.73,-231.225L940.091,-231.225C934.254,-231.225 929.516,-226.147 929.516,-219.891C929.516,-213.636 934.254,-208.557 940.091,-208.557L996.73,-208.557C1002.57,-208.557 1007.31,-213.636 1007.31,-219.891Z",
    transform: "matrix(.86603 .5 0 1.07737 -.648 -33.87)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4b61dc",
    d: "M1007.31,-219.891C1007.31,-226.147 1004.61,-231.225 1001.28,-231.225L935.537,-231.225C932.214,-231.225 929.516,-226.147 929.516,-219.891C929.516,-213.636 932.214,-208.557 935.537,-208.557L1001.28,-208.557C1004.61,-208.557 1007.31,-213.636 1007.31,-219.891Z",
    transform: "matrix(1.52102 .87816 0 1.07737 -634.95 -345.452)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1 -1) rotate(60 1452.411 35.289)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4b61dc",
    d: "M991.226,342.797L991.226,342.795L996.307,345.729L994.099,363.481L994.099,376.243C994.099,381.97 990.734,388.601 986.499,391.37L986.031,395.128L980.95,392.194L980.951,392.188C979.129,391.267 977.964,388.929 977.964,385.558L977.964,358.681C977.964,352.745 981.579,345.837 986.031,343.267C988.009,342.125 989.822,342.029 991.226,342.797Z",
    transform: "translate(-1.657 22.263)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#abb3db",
    d: "M1144.6,795.104C1144.6,789.963 1140.43,785.789 1135.29,785.789C1130.15,785.789 1125.97,789.963 1125.97,795.104L1125.97,818.381C1125.97,823.522 1130.15,827.696 1135.29,827.696C1140.43,827.696 1144.6,823.522 1144.6,818.381L1144.6,795.104Z",
    transform: "rotate(-30 56.547 2.93) skewX(-30)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.551 -184.558) scale(1.2704)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-169.25 -2.377) scale(.97792)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e1e3ee",
    d: "M-571.141,1064.45C-525.753,1062.68 -507.043,1075.53 -513.537,1113.28C-518.51,1142.19 -469.011,1151.64 -488.834,1170.1C-549.18,1226.31 -568.147,1157.31 -568.147,1122.32C-568.147,1087.33 -612.437,1066.06 -571.141,1064.45Z",
    transform: "matrix(.66388 -.38329 .88074 .5085 62.216 37.297)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10243e",
    d: "M736.698,792.702C736.698,792.702 770.343,791.121 784.212,786.797C798.081,782.472 802.68,797.544 785.638,809.198C768.596,820.852 747.003,827.8 741.229,821.767C735.455,815.735 736.698,792.702 736.698,792.702Z",
    transform: "matrix(.9355 0 0 .91353 39.548 76.576)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.803 24.372)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4b61dc",
    d: "M734.631,606.133C734.631,606.133 759.675,729.247 761.565,775.326C761.565,775.326 740.975,801.029 707.097,785.557C707.097,785.557 694.729,651.511 680.982,614.273C680.982,614.273 698.619,595.352 734.631,606.133Z"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M734.631,606.133C734.631,606.133 759.675,729.247 761.565,775.326C761.565,775.326 740.975,801.029 707.097,785.557C707.097,785.557 694.729,651.511 680.982,614.273C680.982,614.273 698.619,595.352 734.631,606.133Z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#10243e",
    d: "M743.106,647.163L745.047,659.043C745.047,659.043 718.723,684.02 686.1,670.931L682.786,649.636L743.106,647.163Z",
    transform: "translate(-1.803 -24.372)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(14.561 677.35 -278.978) scale(.97792)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#10243e",
    d: "M736.698,792.702C736.698,792.702 770.343,791.121 784.212,786.797C798.081,782.472 802.68,797.544 785.638,809.198C768.596,820.852 747.003,827.8 741.229,821.767C735.455,815.735 736.698,792.702 736.698,792.702Z",
    transform: "rotate(-7.243 1475.532 236.879) scale(.88992)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.803 24.372)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4b61dc",
    d: "M734.631,606.133C734.631,606.133 756.723,723.535 758.855,769.276C758.855,769.276 742.938,792.467 705.489,787.466C705.489,787.466 694.729,651.511 680.982,614.273C680.982,614.273 698.619,595.352 734.631,606.133Z"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M734.631,606.133C734.631,606.133 756.723,723.535 758.855,769.276C758.855,769.276 742.938,792.467 705.489,787.466C705.489,787.466 694.729,651.511 680.982,614.273C680.982,614.273 698.619,595.352 734.631,606.133Z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#10243e",
    d: "M743.106,647.163L752.477,672.696C752.477,672.696 730.331,699.117 686.1,670.931L682.786,649.636L743.106,647.163Z",
    transform: "translate(-1.803 -24.372)"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#7887da",
    d: "M693.584,496.165C707.105,505.453 707.503,524.39 707.619,543.332C707.71,558.206 695.072,585.398 695.072,585.398L707.072,643.897C707.072,643.897 601.273,681.601 536.374,599.787L564.548,544.804L589.13,466.608C589.13,466.608 676.039,484.115 693.584,496.165Z",
    transform: "translate(-33.405 79.495) scale(.8613)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(17.99 551.692 568.959)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#88daff",
    d: "M824.522,573.568C824.522,573.568 808.385,572.911 803.05,559.667C803.05,559.667 806.279,542.429 814.434,532.422C822.588,522.415 828.13,522.905 838.448,522.412C848.767,521.919 847.535,530.555 840.907,531.491C835.329,532.278 831.124,533.869 831.434,535.379C831.434,535.379 838.057,535.326 844.093,541.416C850.129,547.505 841.811,555.505 841.811,555.505C841.811,555.505 846.528,563.786 836.829,566.027C836.829,566.027 835.54,572.233 824.522,573.568Z",
    transform: "rotate(-15.287 815.293 693.792) scale(.8613)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7887da",
    d: "M555.223,522.837C555.223,522.837 591.787,523.594 607.073,521.614C614.689,520.627 631.104,497.418 632.228,476.87C632.228,476.87 644.389,465.446 660.364,475.064C670.447,481.134 679.398,492.429 670.457,512.274C670.457,512.274 662.727,539.487 632.691,555.887C611.782,567.304 580.334,562.339 554.981,556.241C554.981,556.241 542.576,537.252 555.223,522.837Z",
    transform: "rotate(34.001 575.143 507.805)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#10243e",
    d: "M766.365,566.594C766.758,564.687 756.371,562.73 748.445,558.944C742.082,555.904 730.574,549.711 726.153,545.683C726.153,545.683 731.564,564.718 745.277,570.587C758.786,576.369 765.753,569.567 766.365,566.594Z",
    transform: "rotate(32.435 464.605 375.122) scale(.8613)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.615 11.945)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 542.636,
    cy: 465.485,
    r: 45.128,
    fill: "#88daff",
    transform: "translate(7.65 -17.564) scale(.9943)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#88daff",
    d: "M779.395,423.19C779.395,423.19 790.293,417.298 795.504,422.034C800.715,426.77 782.333,440.987 782.333,440.987L779.395,423.19Z",
    transform: "translate(-12.034 114.412) scale(.76696)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#10243e",
    d: "M504.311,430.453C504.311,430.453 494.596,435.101 490.798,448.802C487,462.503 482.597,474.879 470.846,476.147C459.094,477.415 447.309,494.953 452.832,507.667C452.832,507.667 431.48,509.052 433.18,535.61C434.88,562.167 458.539,566.525 471.146,561.393C471.146,561.393 482.584,586.726 507.678,573.487C507.678,573.487 540.378,585.777 548.454,561.317C548.454,561.317 581.069,555.081 569.71,528.304C569.71,528.304 586.94,518.056 577.724,500.542C568.509,483.028 571.741,474.765 571.741,474.765C571.741,474.765 582.382,467.847 580.542,453.899C580.542,453.899 610.945,440.503 603.154,418.315C595.362,396.127 568.123,389.755 557.558,411.353C553.526,399.624 514.802,396.321 504.311,430.453Z",
    transform: "translate(-17.674 -24.023)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.73912 0 0 .70885 360.684 -202.866)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#40c3fd",
    d: "M883.382,698.394C886.997,696.278 891.723,696.46 896.891,699.444L988.932,752.584C1000.29,759.139 1009.5,776.752 1009.5,791.891L1009.5,890.821C1009.5,899.058 1006.78,904.876 1002.46,907.414C1002.41,907.441 1002.37,907.468 1002.32,907.494L975.697,922.865L955.525,887.086L896.891,853.234C885.537,846.679 876.319,829.065 876.319,813.926L876.319,746.597L857.551,713.307L883.382,698.394Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#88daff",
    d: "M1143.64,192.098C1143.64,178.988 1133.23,168.343 1120.39,168.343L1013.1,168.343C1000.27,168.343 989.854,178.988 989.854,192.098L989.854,277.774C989.854,290.885 1000.27,301.529 1013.1,301.529L1120.39,301.529C1133.23,301.529 1143.64,290.885 1143.64,277.774L1143.64,192.098Z",
    transform: "rotate(30 -28.112 -6.18) skewX(30)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.228,
    height: 27.274,
    x: 1171.89,
    y: -130.044,
    fill: "#fff",
    transform: "matrix(.83207 .50091 0 1.35277 -103.545 390.453)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.228,
    height: 27.274,
    x: 1171.89,
    y: -130.044,
    fill: "#fff",
    transform: "matrix(.83207 .50091 0 1.93321 -80.865 463.759)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.228,
    height: 27.274,
    x: 1171.89,
    y: -130.044,
    fill: "#fff",
    transform: "matrix(.83207 .50091 0 2.78668 -58.184 565.124)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.228,
    height: 27.274,
    x: 1171.89,
    y: -130.044,
    fill: "#fff",
    transform: "matrix(.83207 .50091 0 2.17779 -35.504 516.202)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.73912 0 0 .70885 360.684 -66)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#40c3fd",
    d: "M883.382,698.394C886.997,696.278 891.723,696.46 896.891,699.444L988.932,752.584C1000.29,759.139 1009.5,776.752 1009.5,791.891L1009.5,890.821C1009.5,899.058 1006.78,904.876 1002.46,907.414C1002.41,907.441 1002.37,907.468 1002.32,907.494L975.697,922.865L955.525,887.086L896.891,853.234C885.537,846.679 876.319,829.065 876.319,813.926L876.319,746.597L857.551,713.307L883.382,698.394Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#88daff",
    d: "M1143.64,192.098C1143.64,178.988 1133.23,168.343 1120.39,168.343L1013.1,168.343C1000.27,168.343 989.854,178.988 989.854,192.098L989.854,277.774C989.854,290.885 1000.27,301.529 1013.1,301.529L1120.39,301.529C1133.23,301.529 1143.64,290.885 1143.64,277.774L1143.64,192.098Z",
    transform: "rotate(30 -28.112 -6.18) skewX(30)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1025.79,599.847L1050.19,585.757L1074.6,599.847L1050.19,613.937L1025.79,599.847ZM1047.77,618.138L1047.77,646.318L1023.36,632.228L1023.36,604.047L1047.77,618.138ZM1077.02,604.047L1077.02,632.228L1052.62,646.318L1052.62,618.138L1077.02,604.047Z",
    transform: "matrix(1.07154 .64507 0 1.29015 -212.312 -656.732)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.73912 0 0 .70885 360.684 68.51)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#40c3fd",
    d: "M883.382,698.394C886.997,696.278 891.723,696.46 896.891,699.444L988.932,752.584C1000.29,759.139 1009.5,776.752 1009.5,791.891L1009.5,890.821C1009.5,899.058 1006.78,904.876 1002.46,907.414C1002.41,907.441 1002.37,907.468 1002.32,907.494L975.697,922.865L955.525,887.086L896.891,853.234C885.537,846.679 876.319,829.065 876.319,813.926L876.319,746.597L857.551,713.307L883.382,698.394Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#88daff",
    d: "M1143.64,192.098C1143.64,178.988 1133.23,168.343 1120.39,168.343L1013.1,168.343C1000.27,168.343 989.854,178.988 989.854,192.098L989.854,277.774C989.854,290.885 1000.27,301.529 1013.1,301.529L1120.39,301.529C1133.23,301.529 1143.64,290.885 1143.64,277.774L1143.64,192.098Z",
    transform: "rotate(30 -28.112 -6.18) skewX(30)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1063.31,756.483C1063.31,756.483 1065.38,758.694 1063.74,763.894C1061.79,770.104 1059.96,779.11 1060.72,786.644C1061.51,794.415 1064.12,798.704 1064.12,798.704C1052.03,796.467 1045.5,794.041 1033.72,786.826C1033.72,786.826 1030.16,782.402 1029.81,774.598C1029.4,765.578 1033.79,755.527 1035.01,748.333C1035.75,744.017 1033.45,741.148 1033.45,741.148C1044.4,745.603 1053.57,749.171 1063.31,756.483ZM1038.53,773.132C1038.53,773.132 1042.57,775.252 1046.94,777.266C1047.48,777.514 1048.12,777.278 1048.36,776.739C1048.61,776.2 1048.38,775.561 1047.84,775.313C1043.52,773.324 1039.53,771.229 1039.53,771.229C1039.01,770.953 1038.36,771.155 1038.08,771.68C1037.81,772.206 1038.01,772.856 1038.53,773.132ZM1040.21,759.922C1040.21,759.922 1051.08,765.62 1056.5,767.228C1057.07,767.396 1057.66,767.071 1057.83,766.503C1058,765.934 1057.68,765.335 1057.11,765.166C1051.81,763.597 1041.21,758.018 1041.21,758.018C1040.68,757.742 1040.04,757.945 1039.76,758.47C1039.48,758.995 1039.68,759.646 1040.21,759.922ZM1038.84,765.745C1038.84,765.745 1049.71,771.443 1055.13,773.051C1055.7,773.219 1056.3,772.894 1056.46,772.326C1056.63,771.757 1056.31,771.158 1055.74,770.989C1050.44,769.42 1039.84,763.841 1039.84,763.841C1039.32,763.565 1038.67,763.768 1038.39,764.293C1038.11,764.818 1038.32,765.469 1038.84,765.745Z",
    transform: "matrix(1.48038 0 0 1.6167 -638.803 -431.214)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(150.674 25.113) scale(.89038)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 183.983,
    height: 76.747,
    x: -569.548,
    y: 1136.04,
    fill: "#88daff",
    transform: "matrix(.78546 -.45348 1.53776 .88783 -710.925 -399.168)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 167.991,
    height: 63.273,
    x: 814.884,
    y: 1165.91,
    fill: "#40c3fd",
    transform: "matrix(.86016 -.49661 0 1.65359 5.763 -587.386)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 135.14,
    height: 90.61,
    x: 679.744,
    y: 457.128,
    fill: "#40c3fd",
    transform: "matrix(.87331 .5042 0 1.1547 -4.954 -2.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 135.14,
    height: 90.61,
    x: 679.744,
    y: 457.128,
    fill: "#e1e3ee",
    transform: "matrix(.1817 .1049 0 .52736 511.9 582.319)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.95,
    height: 28.186,
    x: -527.846,
    y: 1088.9,
    fill: "#f2f3f7",
    transform: "matrix(5.17024 -2.98504 .85878 .49582 2429.72 -1220.64)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-145.965 -179.48) scale(1.22717)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 877.721,
    cy: 889.003,
    fill: "#e1e3ee",
    rx: 21.115,
    ry: 9.004,
    transform: "translate(-9.924 .883)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 877.721,
    cy: 889.003,
    fill: "#e1e3ee",
    rx: 21.115,
    ry: 9.004,
    transform: "matrix(1.34909 0 0 1.24436 -287.844 -211.112)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7887da",
    d: "M838.433,898.119C833.162,887.161 815.313,861.946 826.27,847.845C836.404,834.805 850.049,852.676 852.971,867.264C852.971,867.264 844.283,804.651 865.345,803.464C886.407,802.277 879.17,842.957 875.433,859.855C875.433,859.855 893.722,826.362 906.47,838.374C919.218,850.386 877.53,902.745 877.53,902.745C874.744,907.718 867.016,913.537 857.893,913.593C850.348,913.639 842.025,905.587 838.433,898.119Z",
    transform: "translate(12.374 -23.201)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f3f7",
    d: "M878.738,795.336C878.775,794.743 879.287,794.293 879.879,794.331C880.471,794.368 880.921,794.879 880.884,795.471C880.884,795.471 876.527,864.212 869.915,890.957C869.773,891.533 869.19,891.885 868.614,891.743C868.038,891.6 867.686,891.017 867.828,890.441C874.413,863.803 878.738,795.336 878.738,795.336Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f3f7",
    d: "M851.167 841.899C851.041 841.32 851.409 840.747 851.989 840.621 852.569 840.495 853.142 840.863 853.268 841.443 853.268 841.443 855.421 851.349 860.07 860.615 863.096 866.647 867.16 872.44 872.452 874.865 872.992 875.113 873.229 875.751 872.982 876.291 872.735 876.83 872.096 877.067 871.557 876.82 865.866 874.212 861.402 868.065 858.148 861.579 853.376 852.068 851.167 841.899 851.167 841.899zM874.738 862.478C874.186 862.696 873.561 862.426 873.342 861.875 873.123 861.323 873.393 860.698 873.945 860.479 873.945 860.479 896.89 851.407 905.683 833.186 905.941 832.651 906.584 832.427 907.119 832.685 907.653 832.943 907.878 833.586 907.62 834.12 898.498 853.021 874.738 862.478 874.738 862.478z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#10243e",
    d: "M890.496,864.055C903.226,863.912 899.717,872.701 907.727,877.88C915.065,882.625 914.901,892.996 903.139,895.137C891.378,897.278 881.4,896.939 873.266,894.478C858.592,890.037 861.515,879.578 870.899,876.523C878.665,873.996 881.049,864.16 890.496,864.055Z",
    transform: "translate(8.56 .309)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 901.391,
    cy: 872.661,
    fill: "#e1e3ee",
    rx: 1.934,
    ry: 1.863,
    transform: "translate(-466.967 -452.088) scale(1.51916)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 906.34,
    cy: 878.462,
    fill: "#e1e3ee",
    rx: 1.007,
    ry: 1.354,
    transform: "matrix(1.46885 0 0 1 -424.468 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-45 1589.15 3204.408) scale(1.4175)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2144.31,
    cy: 280.09,
    r: 73.208,
    fill: "#4b61dc",
    transform: "translate(-18.874 -21.204)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f3f7",
    d: "M454.44,201.169C454.44,194.298 460.019,188.719 466.89,188.719C473.762,188.719 479.34,194.298 479.34,201.169C479.34,201.169 479.34,236.025 479.34,236.025L539.872,236.025C546.743,236.025 552.322,241.604 552.322,248.475C552.322,255.346 546.743,260.925 539.872,260.925L466.89,260.925C460.014,260.925 454.44,255.351 454.44,248.475L454.44,201.169Z",
    transform: "translate(1746.01 83.92) scale(.76131)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4b61dc",
    d: "M2121.8,306.453C2123.12,303.438 2125.69,301.556 2128.48,301.556C2131.27,301.556 2133.84,303.438 2135.16,306.453C2144.91,328.716 2161.89,367.49 2161.89,367.49L2095.06,367.49C2095.06,367.49 2112.05,328.716 2121.8,306.453Z",
    transform: "matrix(-1 0 0 -.81615 4253.92 599.916)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment01);
export default __webpack_public_path__ + "static/media/payment01.4ca39dc7f8c09aab7c17729d12716e1b.svg";
export { ForwardRef as ReactComponent };